import { application } from "./application";
import ActivationRowController from "./activation_row_controller";
import ClearableInputController from "./clearable_input_controller";
import CopyOnClickController from "./copy_on_click_controller";
import CsvImportController from "./csv_import_controller";
import ExpandableCellController from "./expandable_cell_controller";
import FlashAutocloseController from "./flash_autoclose_controller";
import FormDirtyTrackerController from "./form_dirty_tracker_controller";
import MergeAccountsController from "./merge_accounts_controller";
import OrganizationDomainsController from "./organization_domains_controller";
import EmailValidationController from "./email_validation_controller";
import PublisherKeyFormController from "./publisher_key_form_controller";
import PublisherUserFormController from "./publisher_user_form_controller";
import SelectPlaceholderController from "./select_placeholder_controller";
import SidebarController from "./sidebar_controller";
import TomSelectController from "./tom_select_controller";
import TooltipController from "./tooltip_controller";
import UserEditController from "./user_edit_controller";

application.register("user-edit", UserEditController);
application.register("tom-select", TomSelectController);
application.register("activation-row", ActivationRowController);
application.register("copy-on-click", CopyOnClickController);
application.register("form-dirty-tracker", FormDirtyTrackerController);
application.register("merge-accounts", MergeAccountsController);
application.register("organization-domains", OrganizationDomainsController);
application.register("csv-import", CsvImportController);
application.register("expandable-cell", ExpandableCellController);
application.register("clearable-input", ClearableInputController);
application.register("email-validation", EmailValidationController);
application.register("publisher-key-form", PublisherKeyFormController);
application.register("publisher-user-form", PublisherUserFormController);
application.register("tooltip", TooltipController);
application.register("flash-autoclose", FlashAutocloseController);
application.register("select-placeholder", SelectPlaceholderController);
application.register("sidebar", SidebarController);
